document.addEventListener('DOMContentLoaded', function() {
    const quantitySelectors = document.querySelectorAll('.Quantity_Selector');

    window.addEventListener("global:align", function(){
        const newQuantitySelectors = document.querySelectorAll('.Quantity_Selector:not([data-registered])');
        newQuantitySelectors.forEach((quantitySelector) => {
            registerQuantitySelectors(quantitySelector);
        });
    });
    
    quantitySelectors.forEach((quantitySelector) => {
        registerQuantitySelectors(quantitySelector);
    });

    function registerQuantitySelectors(quantitySelector){
        quantitySelector.dataset.registered = true;
        const lineItem = quantitySelector.closest('.Cart_Item');

        const minusButton = quantitySelector.querySelector('.Minus');
        const plusButton = quantitySelector.querySelector('.Plus');
        const quantityInput = quantitySelector.querySelector('input[name="quantity"]');

        regularEvents(minusButton, plusButton, quantityInput);

        if(lineItem != null){
            cartEvents(quantityInput, lineItem.dataset.key);
            return;
        }
    }

    function regularEvents(minusButton, plusButton, quantityInput){
        quantityInput.dataset.previousValue = quantityInput.value;

        minusButton.addEventListener('click', function() {
            let currentValue = parseInt(quantityInput.value);
            if (currentValue > 1) {
                quantityInput.value = currentValue - 1;
            }
            quantityInput.dispatchEvent(new CustomEvent('quantity:change', { detail: { previousValue: currentValue, delete: (currentValue == 1) } }));
        });

        plusButton.addEventListener('click', function() {
            let currentValue = parseInt(quantityInput.value);
            quantityInput.value = currentValue + 1;
            quantityInput.dispatchEvent(new CustomEvent('quantity:change', { detail: { previousValue: currentValue } }));
        });

        quantityInput.addEventListener('input', function() {
            let currentValue = parseInt(quantityInput.value);
            if (isNaN(currentValue) || currentValue < 1) {
                quantityInput.value = 1;
            }
            const previousValue = quantityInput.dataset.previousValue || quantityInput.value;
            
            quantityInput.dispatchEvent(new CustomEvent('quantity:change', { detail: { previousValue: previousValue } }));
        });
    }

    function cartEvents(quantityInput, key){
        quantityInput.addEventListener('quantity:change', async function(e) {
            const value = e.detail.delete ? 0 : quantityInput.value;
            if(value == 0) quantityInput.closest('.Cart_Item').style.display = 'none';
            if(!await serverConfirmation(key, value)){
                quantityInput.value = e.detail.previousValue;
                if(value == 0) quantityInput.closest('.Cart_Item').style.display = 'block';
                window.dispatchEvent(new CustomEvent('cart:update'));
                return;
            }
            else{
                window.dispatchEvent(new CustomEvent('cart:update'));
                quantityInput.dataset.previousValue = value;
                return;
            }
        });
    }

    async function serverConfirmation(key, value, ){
        const res = await fetch(`/cart/change?id=${ key }&quantity=${value}`).then(response => {return response}).catch(e => console.error("Error:",e));
        console.log(key, value, res);
        return res.status == 200;
    }
});